/* urh-holo.js — the live site's holo motion (v13 snippets/urh-base), moved to an asset for v15.
   Same math as live. Changes:
   - picks up holo prints added later (MutationObserver + Shopify theme-editor events + a slow re-scan)
   - reduced motion no longer freezes it: idle drift stays, cursor / touch / gyro still move the light
   - reads Theme settings > Holo effect (window.URH_HOLO): follow cursor/touch/gyro, idle drift
   - iOS motion permission is asked quietly on the first tap (no button) */
(function(){
  if(window.__urhHolo2) return; window.__urhHolo2 = true; window.__urhHolo = true;
  var C = window.URH_HOLO || {};
  var FOLLOW = C.follow !== false, DRIFT = C.drift !== false;
  var ptr=null, ori=null, oriReq=false;
  function onPtr(e){ ptr={x:e.clientX,y:e.clientY,t:performance.now()}; }
  function onTouch(e){ var t=e.touches&&e.touches[0]; if(t) ptr={x:t.clientX,y:t.clientY,t:performance.now()}; }
  function onOri(e){ if(e.gamma==null&&e.beta==null) return; ori={g:e.gamma||0,b:e.beta||0,t:performance.now()}; }
  function enableOri(){ if(oriReq) return; oriReq=true; var D=window.DeviceOrientationEvent;
    if(D&&typeof D.requestPermission==='function'){ D.requestPermission().then(function(s){ if(s==='granted') window.addEventListener('deviceorientation',onOri); }).catch(function(){ oriReq=false; }); } }
  if(FOLLOW){
    window.addEventListener('pointermove',onPtr,{passive:true});
    window.addEventListener('touchmove',onTouch,{passive:true});
    window.addEventListener('touchstart',onTouch,{passive:true});
    window.addEventListener('pointerdown',enableOri,{passive:true});
    window.addEventListener('touchend',enableOri,{passive:true});
    window.addEventListener('click',enableOri,{passive:true});
    var DO=window.DeviceOrientationEvent; if(DO&&typeof DO.requestPermission!=='function') window.addEventListener('deviceorientation',onOri);
  }

  var els=[], dirty=true;
  function collect(){ els=Array.prototype.slice.call(document.querySelectorAll('[data-urh-holo]')); dirty=false; }
  function mark(){ dirty=true; }
  window.URHHolo = { collect: collect, refresh: mark };
  document.addEventListener('DOMContentLoaded',mark); window.addEventListener('load',mark);
  ['shopify:section:load','shopify:section:unload','shopify:section:select','shopify:section:deselect','shopify:section:reorder','shopify:block:select','shopify:block:deselect'].forEach(function(n){ document.addEventListener(n,mark); });
  if(window.MutationObserver){
    var mo=new MutationObserver(function(list){
      for(var i=0;i<list.length;i++){ var a=list[i].addedNodes, r=list[i].removedNodes; if((a&&a.length)||(r&&r.length)){ dirty=true; return; } }
    });
    var start=function(){ mo.observe(document.documentElement,{childList:true,subtree:true}); };
    if(document.documentElement) start();
  }
  var tick=0, state=new WeakMap();
  function frame(now){
    if(dirty || (++tick % 90)===0) collect();
    var ptT=ptr?ptr.t:-1e9, orT=ori?ori.t:-1e9, active=FOLLOW && (now-Math.max(ptT,orT))<2500;
    for(var i=0;i<els.length;i++){
      var el=els[i]; if(!el.isConnected) continue;
      var st=state.get(el); if(!st){ st={lx:50,ly:40,rx:0,ry:0}; state.set(el,st); }
      var r=el.getBoundingClientRect(); if(!r.width || r.bottom<-200 || r.top>innerHeight+200) continue;
      var maxT=parseFloat(el.dataset.tilt||'7'); var lx,ly,rx,ry;
      if(active){
        if(orT>=ptT && ori){ var g=Math.max(-45,Math.min(45,ori.g)), b=Math.max(0,Math.min(90,ori.b));
          lx=50+(g/45)*55; ly=50+((b-45)/45)*45; ry=(g/45)*maxT; rx=-((b-45)/45)*maxT; }
        else { var cx=r.left+r.width/2, cy=r.top+r.height/2;
          var nx=Math.max(-1,Math.min(1,(ptr.x-cx)/(Math.max(r.width,innerWidth*0.6)))), ny=Math.max(-1,Math.min(1,(ptr.y-cy)/(Math.max(r.height,innerHeight*0.6))));
          lx=50+nx*60; ly=50+ny*60; ry=nx*maxT; rx=-ny*maxT; }
      } else if(DRIFT){ var t=now/1000 + i*1.7; lx=50+Math.sin(t*0.5)*45; ly=45+Math.cos(t*0.37)*35; ry=Math.sin(t*0.5)*maxT*0.45; rx=Math.cos(t*0.37)*maxT*0.35; }
      else { lx=30; ly=35; rx=0; ry=0; }
      var k=0.09; st.lx+=(lx-st.lx)*k; st.ly+=(ly-st.ly)*k; st.rx+=(rx-st.rx)*k; st.ry+=(ry-st.ry)*k;
      el.style.setProperty('--lx',st.lx.toFixed(2)); el.style.setProperty('--ly',st.ly.toFixed(2));
      el.style.setProperty('--rx',st.rx.toFixed(2)+'deg'); el.style.setProperty('--ry',st.ry.toFixed(2)+'deg');
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
